<template>
    <v-content>
        <h3 v-if="isApproved" class="pb-3 font-weight-bold approved-title">
            Заявка одобрена
        </h3>
        <h3 v-else class="pb-3 font-weight-bold approved-title">
            Заявка не одобрена
        </h3>
        <v-flex v-if="formIsChanged" class="mortgage-list__subtitle lg7 md7 sm8 mb-4">
            <p class="subtitle-text">Необходимо провести перерасчет полиса из-за измененных данных.</p>
        </v-flex>
        <v-flex v-else class="mortgage-list__subtitle lg7 md7 sm8 mb-2">
            <p class="subtitle-text">Вы будете направлены на платежную страницу страховой, после чего полис отправится на почту, и будет сохранен в Личном кабинете.</p>
        </v-flex>
        <v-flex class="color-wrapper lg7 md7 sm8 mb-2" v-if="titleRequired" >
            <h3>ВАЖНО!</h3>
            <p>Обычно титул страхуют по сделкам на вторичном рынке недвижимости, в течение первых 3-х лет после сделки.</p>
            <p>Рекомендуем уточнить в банке обязательно ли Вам страховать Титул</p>
        </v-flex>


        <v-layout v-if="this.policyType.life && this.policyType.apartment && !isPolicyTypeChanged" pt-0 row wrap>
            <v-radio-group v-model="type" row
                           v-on:change="changeShowType"
            >
                <v-radio label="Показать комбинации"
                         value="union">
                </v-radio>
                <v-radio label="Показать отдельно"
                         value="separate">
                </v-radio>
            </v-radio-group>
        </v-layout>
        <mortgage-result-list
            v-if="!isPolicyTypeChanged"
            :data="showData"
            :policyType="policyType"
            :duration = "duration"
            :phone = "phone"
            :isResult = "isResult"
            :wait = "wait"
            :showCommission = "showCommission"
            :formIsChanged="formIsChanged"
            :precalcBank="precalcBank"
            :step="step"
            @nextStep="nextStep"
            @issue="issue"
            :orderStatus="orderStatus"
            :successProcessing="successProcessing"
            @showConfirmModal="showConfirmModal"
        ></mortgage-result-list>
    </v-content>
</template>
<script>

import MortgageResultList from "./MortgageResultList";

export default {
    name: "MortgageCalcResult",
    components: {
        'mortgage-result-list': MortgageResultList
    },
    props: [
        'data',
        'policyType',
        'duration',
        'phone',
        'isResult',
        'wait',
        'showCommission',
        'formIsChanged',
        'orderStatus',
        'successProcessing',
        'precalcBank',
        'step',
        'showType',
        'isPolicyTypeChanged',
        'titleRequired'
    ],
    data: () => ({
        type: null,
        showData: {
            type : null,
            life : null,
            property: null,
            title: null,
            union: null,
        }
    }),

    computed: {
        isApproved() {
            return this.data.filter(el => !el.error).length > 0
        }
    },

    watch: {
        data() {
            this.showData = this.setShowData()
        },
        showType() {
            this.type = this.showType;
        }
    },

    created() {
        this.type = this.showType;
        this.showData = this.setShowData()
    },

    methods: {
        changeShowType() {
            this.$nextTick(() => {
                this.$emit('setShowType', this.type);
                this.showData = this.setShowData()
            });
        },

        setShowData() {
            if (this.type === 'separate') {
                return {
                    type: 'separate',
                    property: this.data ? this.data.filter(val => { return val.type === 'apartment'}) : {},
                    life: this.data ? this.data.filter(val => { return val.type === 'life'}) : {},
                    title: this.data ? this.data.filter(val => { return val.type === 'apartment' && val.title}) : {}
                    /*title: this.data ? this.data.filter(val => { return val.type === 'apartment'}) : {}*/
                }
            }
            return {
                type: 'union',
                union: this.data ? this.data.filter(val => { return val.type === 'lifeAndApartment'}) : {},
                titleUnion: this.data ? this.data.filter(val => { return val.type === 'lifeAndApartment' && val.title}) : {}
                /*titleUnion: this.data ? this.data.filter(val => { return val.type === 'lifeAndApartment'}) : {}*/
            }
        },

        nextStep() {
            this.$emit('nextStep')
        },
        issue(data) {
            this.$emit('issue', data)
        },
        showConfirmModal(confirmModalItems) {
            this.$emit('showConfirmModal', confirmModalItems)
        }
    },
}
</script>

<style scoped>
.color-wrapper {
    display: inline-block;
    padding: 20px 20px 4px;

    background: #e3e3e3;
    border-radius: 15px;
}

.color-wrapper h3 {
    font-size: 20px;
    margin-bottom: 10px;
}

.color-wrapper p {
    margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageCalcResult.vue